// UserComponent.js
import React, { useEffect, useState } from 'react';
import logo from '../images/kalingarayanrunners_logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import { toaster } from '../Recoil/ActiveEvents';
import { useRecoilState } from 'recoil';

function Header() {
  const [notify, setNotify] = useRecoilState(toaster);

  const navigate = useNavigate();
  const clearsession = (value) => {
    let tampObj = {'showPopup': true, 'message':'You have been successfully logged out',type:'success'}
    setNotify(tampObj)
    sessionStorage.removeItem('authToken');
    navigate('/');
  }
  
  useEffect(() => {

  }, []);

  return (
    <div>
             <header className="relative p-4 fixed top-0 left-0 w-full z-[3]">
              <div className="container mx-auto flex justify-between items-center">
                  <div className="text-2xl font-semibold">
                    <Link to="/admin"> <img 
                          src= {logo} 
                          alt="Logo" 
                          className="sm:max-w-[14rem] max-w-[12rem]  transform scale-140" 
                      /></Link>
                  </div>
                  <nav>
                      <ul className="flex">
                          {/* <li><Link to="/registration" className="text-sm text-white"><button className='bg-red-600 w-28 h-10 rounded-l-lg'>Register</button></Link></li> */}
                          <li><button className='text-sm text-white bg-emerald-600 w-28 h-10 rounded' onClick={()=>clearsession(true)}>Logout</button></li> 
                      </ul>
                  </nav>
              </div>
          </header>         
      </div>
  );
}

export default Header;
